import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';
import I18nLabel from '@/core/i18n-label/I18nLabel.vue';
import axios from 'axios';
import ReleaseNotes from '@/core/release-notes-dialog/release-notes.vue';

@Component({
    components: {
        I18nLabel,
        ReleaseNotes,
    },
})
export default class Navbar extends Vue {
    @Inject('loginService')
    private loginService: () => LoginService;
    @Inject('translationService') private translationService: () => TranslationService;

    @Inject('accountService') private accountService: () => AccountService;
    private currentLanguage = this.$store.getters.currentLanguage;
    private languages: any = this.$store.getters.languages;
    private navigationVisible = false;
    private userAuthorities: string[] = [];

    public showReleaseNotes: boolean = false;

    created() {
        this.translationService().refreshTranslation(this.currentLanguage);
    }

    public subIsActive(input) {
        const paths = Array.isArray(input) ? input : [input];
        return paths.some(path => {
            return this.$route.path.indexOf(path) === 0; // current path starts with this path string
        });
    }

    public changeLanguage(newLanguage: string): void {
        this.translationService().refreshTranslation(newLanguage);
    }

    public isActiveLanguage(key: string): boolean {
        return key === this.$store.getters.currentLanguage;
    }

    public logout(): void {
        localStorage.removeItem('jhi-authenticationToken');
        sessionStorage.removeItem('jhi-authenticationToken');
        this.$store.commit('logout');
        this.$router.push('/login', () => {});
    }

    public get authenticated(): boolean {
        return this.$store.getters.authenticated;
    }

    public get account(): object {
        return this.$store.getters.account;
    }

    public hasAnyAuthority(authorities: any): boolean {
        for (let i = 0; i < authorities.length; i++) {
            if (this.userAuthorities.includes(authorities[i])) {
                return true;
            }
        }

        return false;
    }

    public get openAPIEnabled(): boolean {
        return this.$store.getters.activeProfiles.indexOf('api-docs') > -1;
    }

    public get version(): boolean {
        return this.$store.getters.version;
    }

    @Watch('authenticated')
    public loadAuthorities(): void {
        this.accountService()
            .getAuthorities()
            .then(authorities => (this.userAuthorities = authorities));
    }

    public clearCache(): void {
        axios.post('api/dev/clear-cache');
    }
}
